export const DEFAULT_BRANCH_OPERATIONAL_MODULES = Object.freeze({
  serviceMode: "salon",
  salonEnabled: true,
  deliveryEnabled: false,
  operationalSetupCompleted: false,
  wePedidosEnabled: false,
  waiterEnabled: true,
  stockEnabled: true,
  aiEnabled: true,
});

export const normalizeBranchOperationalModules = (
  source = {},
  { wePedidosEnabled } = {}
) => {
  const serviceMode =
    source.serviceMode === "kiosk" || source.service_mode === "kiosk"
      ? "kiosk"
      : "salon";
  const salonEnabled =
    serviceMode === "kiosk"
      ? false
      : (source.salonEnabled ?? source.salon_enabled) !== false;
  const deliveryEnabled =
    (source.deliveryEnabled ?? source.delivery_enabled) === true;

  return {
    serviceMode,
    salonEnabled,
    deliveryEnabled,
    operationalSetupCompleted:
      (source.operationalSetupCompleted ??
        source.operational_setup_completed) === true,
    wePedidosEnabled:
      deliveryEnabled &&
      (wePedidosEnabled ?? source.wePedidosEnabled ?? source.we_pedidos_enabled) ===
        true,
    waiterEnabled:
      salonEnabled && (source.waiterEnabled ?? source.waiter_enabled) !== false,
    stockEnabled: (source.stockEnabled ?? source.stock_enabled) !== false,
    aiEnabled: (source.aiEnabled ?? source.ai_enabled) !== false,
  };
};

export const applyBranchOperationalModuleToggle = (
  current,
  key,
  enabled
) => {
  const next = { ...current, [key]: enabled === true };

  if (key === "salonEnabled" && !enabled) {
    next.waiterEnabled = false;
  }

  if (key === "deliveryEnabled" && !enabled) {
    next.wePedidosEnabled = false;
  }

  if (key === "waiterEnabled" && enabled) {
    next.salonEnabled = true;
  }

  if (key === "wePedidosEnabled" && enabled) {
    next.deliveryEnabled = true;
  }

  if (next.serviceMode === "kiosk") {
    next.salonEnabled = false;
    next.waiterEnabled = false;
  }

  return next;
};

export const getBranchOperationalModulesError = (modules = {}) => {
  if (
    modules.serviceMode !== "kiosk" &&
    !modules.salonEnabled &&
    !modules.deliveryEnabled
  ) {
    return "Activa al menos Salon o Delivery para mantener un canal de venta.";
  }

  if (modules.wePedidosEnabled && !modules.deliveryEnabled) {
    return "We! pedidos requiere que Delivery y retiro esten activos.";
  }

  if (modules.waiterEnabled && !modules.salonEnabled) {
    return "El equipo de mozos requiere que Salon y mesas este activo.";
  }

  return "";
};
